import { State } from "../../../state";
import { ApplyActionVisibility } from "../_CostsAndOutcomes/ApplyActionVisibility";
import { ApplyCostScaleChange } from "../_CostsAndOutcomes/ApplyCostScaleChange";
import { meetsCostRequirementsSets } from "../_CostsAndOutcomes/meetsCostRequirementsSets";
import { applyCostsSets } from "../_CostsAndOutcomes/applyCostsSets";
import { applyOutcomesSets } from "../_CostsAndOutcomes/applyOutcomesSets";
import { applyAchievementChecks } from "../../../Achievements/checkAchievements";

export const BuySetGeneric = (
  actionId: string,
  state: State,
  buyAmount: number = 1,
) => {
  const newBricks = new Map(state.bricks);
  const newSets = new Map(state.sets);
  const newActions = new Map(state.actions);
  const newActionTimestamps = state.actionTimestamps;
  const newTotalSetsPurchased = state.totalSetsPurchased;
  const newSetsPurchasedByType = state.setsPurchasedByType;

  const action = new Map(state.actions).get(actionId)!;

  // Check if action meets cost requirements (both bricks and sets)
  if (!meetsCostRequirementsSets(action, newBricks, newSets, buyAmount))
    return state;

  // Apply Action Visibility (unlock new actions/sets)
  const { newActions: updatedActions, newActionOrder } = ApplyActionVisibility(
    action,
    newActions,
    state.actionOrder,
  );

  // Apply Costs (deduct bricks and sets)
  const costResult = applyCostsSets(
    action,
    newBricks,
    newSets,
    newActionTimestamps,
    buyAmount,
  );
  if (costResult === null) return state;

  // Apply Outcomes (add set count)
  const outcomeResult = applyOutcomesSets(
    action,
    costResult.newBricks,
    costResult.newSets,
    newActionTimestamps,
    buyAmount,
  );
  if (outcomeResult === null) return state;

  // Apply Increase in costScale (flat multiplication for bulk purchases)
  ApplyCostScaleChange(action, updatedActions, buyAmount);

  // Apply Achievement Data
  // Extract set ID from action ID (e.g., "buy_set_6772-1" -> "6772-1")
  const setId = actionId.replace("buy_set_", "");
  const currentSetCount = newSetsPurchasedByType.get(setId) ?? 0;
  newSetsPurchasedByType.set(setId, currentSetCount + buyAmount);

  const newState = {
    ...state,
    actionTimestamps: newActionTimestamps,
    bricks: outcomeResult.newBricks,
    sets: outcomeResult.newSets,
    actions: updatedActions,
    actionOrder: newActionOrder,
    totalSetsPurchased: newTotalSetsPurchased + buyAmount,
    setsPurchasedByType: newSetsPurchasedByType,
  };

  return applyAchievementChecks(newState);
};
